import { useEffect, useState } from "react"
import routes from "routes"
import { ContractProvider, useContractState } from "hooks/useContract"
import { ThemeProvider as ThemeProviderBase } from "styled-components"
import variables from "styles/_export.module.scss"
import { useAddress } from "hooks"
import Header from "./Header"
import container from "components/Container"
import styled from "styled-components"
import usePairs from "rest/usePairs"
import useMigration from "hooks/useMigration"

const ThemeProvider = ThemeProviderBase as unknown as React.FC<any>

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  margin-top: 60px;
  min-height: calc(100vh - 120px);
  padding-top: clamp(32px, 8vh, 120px);

  @media screen and (max-width: ${({ theme }) => theme.breakpoint}) {
    margin-top: 88px;
    min-height: calc(100vh - 132px);
    padding-top: 88px;
  }
`

const Container = styled(container)`
  padding: 0;
`

const App = () => {
  const { isMigrationPage } = useMigration()
  const address = useAddress()
  const contract = useContractState(address)
  const { isLoading: isV2PairsLoading } = usePairs("v2")
  const { isLoading: isV1PairsLoading } = usePairs("v1")

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      if (!isV2PairsLoading && !isV1PairsLoading) {
        setIsLoading(false)
      }
    }, 100)
  }, [isV2PairsLoading, isV1PairsLoading])

  useEffect(() => {
    if (isMigrationPage) {
      document.body.style.backgroundImage =
        "linear-gradient(to right, #0222ba 0%, #01115d 100%)"
    } else {
      document.body.style.backgroundImage = ""
    }
  }, [isMigrationPage])

  return (
    <ThemeProvider theme={variables}>
      <ContractProvider value={contract}>
        <Header />
        {!isLoading && (
          <div>
            <Container>
              <Wrapper>
                <div>{routes()}</div>
              </Wrapper>
            </Container>
          </div>
        )}
      </ContractProvider>
    </ThemeProvider>
  )
}

export default App
